import type { BankTransferErrorCode } from '@repo/api-contracts';
import { TRPCClientError } from '@trpc/client';
import { getTrpcErrorCode } from '@/shared/lib';

const MESSAGES: Record<BankTransferErrorCode, string> = {
  BANK_TRANSFER_UNAVAILABLE: '지금은 계좌이체를 사용할 수 없습니다.',
  BANK_TRANSFER_ALREADY_OPEN: '이미 계좌이체로 주문한 건입니다. 입금 안내를 확인해 주세요.',
  PAYMENT_ALREADY_APPROVED: '이미 결제가 완료된 주문입니다.',
  DEPOSIT_NOT_PENDING: '입금 대기 중인 주문이 아닙니다.',
  REFUND_NOT_PENDING: '환불 대기 중인 주문이 아닙니다.',
  REFUND_ACCOUNT_REQUIRED: '환불받을 계좌를 입력해 주세요.',
  BUSINESS_NUMBER_INVALID: '사업자등록번호는 숫자 10자리여야 합니다.',
  BUSINESS_NUMBER_CLOSED: '폐업한 사업자등록번호로는 세금계산서를 요청할 수 없습니다.',
  SUPPLIER_SETTINGS_INCOMPLETE: '입금 계좌 설정이 완료되지 않았습니다.',
};
export const bankTransferMessage = (code: string | null | undefined): string =>
  code && Object.hasOwn(MESSAGES, code)
    ? MESSAGES[code as BankTransferErrorCode]
    : '계좌이체 주문을 처리하지 못했습니다. 다시 시도해 주세요.';

/** 서버의 고객용 안내를 우선하고 통신·검증 오류는 한글 기본 안내로 바꾼다. */
export const bankTransferApiErrorMessage = (error: unknown): string => {
  if (error instanceof TRPCClientError && getTrpcErrorCode(error) !== null) {
    const data: unknown = error.data;
    if (
      !(
        typeof data === 'object' &&
        data !== null &&
        'fieldErrors' in data &&
        data.fieldErrors != null
      ) &&
      error.message
    )
      return error.message;
  }
  const code =
    typeof error === 'object' && error !== null && 'code' in error && typeof error.code === 'string'
      ? error.code
      : null;
  return bankTransferMessage(code);
};
